import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/articles';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = heroSlides.length;

  const goTo = useCallback((index: number) => {
    setCurrent((index + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => goTo(current + 1), 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((s, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={s.image}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center">
          <div key={current} className="animate-fade-in-up">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-3">
              {slide.title}
            </h1>
            <p className="text-lg md:text-xl text-background-50/90 mb-2 font-heading">
              {slide.subtitle}
            </p>
            <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-xl mx-auto">
              {slide.description}
            </p>
            <Link
              to={slide.link}
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium transition-all hover:bg-primary-600 active:scale-95"
            >
              {slide.linkText}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              i === current ? 'bg-background-50 w-6' : 'bg-background-50/40 hover:bg-background-50/70'
            }`}
            aria-label={`第 ${i + 1} 张`}
          />
        ))}
      </div>

      <button
        onClick={() => goTo(current - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 transition-all cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={() => goTo(current + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 text-background-50 transition-all cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </section>
  );
}